export default __webpack_public_path__ + "static/media/patient.10ff1930.png";